import { render, staticRenderFns } from "./LastEventsTable.vue?vue&type=template&id=6d7f5c2d&"
import script from "./LastEventsTable.vue?vue&type=script&lang=js&"
export * from "./LastEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports